import * as React from 'react';
import { memo } from 'react';

import { usePopup } from 'core/hooks';

import { GlobalModalComponent } from './GlobalModal';

export const GlobalModal = memo(() => {
  const [active, , ownsOverlay] = usePopup();

  return (
    <GlobalModalComponent bare={ownsOverlay}>
      {active ? React.createElement(active) : null}
    </GlobalModalComponent>
  );
});
